import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import api from "@/lib/api";

export default function PublicLayout() {
  const [settings, setSettings] = useState({});
  const location = useLocation();

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data || {})).catch(() => {});
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
      <CookieBanner settings={settings} />
    </div>
  );
}
